var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16705 3.49964C1.16707 2.85532 1.68939 2.33301 2.33371 2.33301H4.08366C4.40583 2.33301 4.66699 2.59418 4.66699 2.91634C4.66699 3.23851 4.40583 3.49967 4.08366 3.49967H2.33371L2.33366 5.24969C2.33365 5.57186 2.07247 5.83302 1.75031 5.83301C1.42814 5.833 1.16698 5.57182 1.16699 5.24966L1.16705 3.49964ZM9.33366 2.91634C9.33366 2.59418 9.59483 2.33301 9.91699 2.33301H11.667C12.3113 2.33301 12.8337 2.85534 12.8337 3.49967V5.24967C12.8337 5.57184 12.5725 5.83301 12.2503 5.83301C11.9282 5.83301 11.667 5.57184 11.667 5.24967V3.49967H9.91699C9.59483 3.49967 9.33366 3.23851 9.33366 2.91634ZM1.75035 8.16634C2.07252 8.16634 2.33369 8.4275 2.33369 8.74967L2.33372 10.4997H4.08366C4.40583 10.4997 4.66699 10.7608 4.66699 11.083C4.66699 11.4052 4.40583 11.6663 4.08366 11.6663H2.33372C1.6894 11.6663 1.16706 11.144 1.16705 10.4997L1.16703 8.74968C1.16702 8.42752 1.42819 8.16635 1.75035 8.16634ZM12.2503 8.16634C12.5725 8.16634 12.8337 8.42751 12.8337 8.74967V10.4997C12.8337 11.144 12.3113 11.6663 11.667 11.6663H9.91699C9.59483 11.6663 9.33366 11.4052 9.33366 11.083C9.33366 10.7608 9.59483 10.4997 9.91699 10.4997H11.667V8.74967C11.667 8.42751 11.9282 8.16634 12.2503 8.16634Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12533 4.08301C6.44749 4.08301 6.70866 4.34418 6.70866 4.66634V9.33301C6.70866 9.65517 6.44749 9.91634 6.12533 9.91634C5.80316 9.91634 5.54199 9.65517 5.54199 9.33301V4.66634C5.54199 4.34418 5.80316 4.08301 6.12533 4.08301Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37533 4.08301C4.69749 4.08301 4.95866 4.34418 4.95866 4.66634V9.33301C4.95866 9.65517 4.69749 9.91634 4.37533 9.91634C4.05316 9.91634 3.79199 9.65517 3.79199 9.33301V4.66634C3.79199 4.34418 4.05316 4.08301 4.37533 4.08301Z",
    fill: "#00AEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87533 4.08301C8.19749 4.08301 8.45866 4.34418 8.45866 4.66634V9.33301C8.45866 9.65517 8.19749 9.91634 7.87533 9.91634C7.55316 9.91634 7.29199 9.65517 7.29199 9.33301V4.66634C7.29199 4.34418 7.55316 4.08301 7.87533 4.08301Z",
    fill: "#00AEEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62533 4.08301C9.94749 4.08301 10.2087 4.34418 10.2087 4.66634V9.33301C10.2087 9.65517 9.94749 9.91634 9.62533 9.91634C9.30316 9.91634 9.04199 9.65517 9.04199 9.33301V4.66634C9.04199 4.34418 9.30316 4.08301 9.62533 4.08301Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIcon);
export default __webpack_public_path__ + "static/media/barcodeIcon.d0c41f4892b9561384953b69f8f66e25.svg";
export { ForwardRef as ReactComponent };